import React, { Component } from 'react';

import Loading from '../../Components/Loading.js';
import FormList from '../../Fields/FormList.js';

import { getApplications } from '../../Api/UserActions.js';
import { getDateString, getJsonDate } from '../../Utilities/JsonFunctions.js';
import { getTranslation } from '../../Utilities/GetTranslation.js';

declare var globalSns;

class Applications extends Component {
    constructor(props) {
        super(props);

        this.state = {};

        this.editApplication = this.editApplication.bind(this);
    }

    componentWillMount() {
        this.loadData();
    }

    loadData() {
        getApplications(globalSns.languageId, (data) => {
            this.setState({
                applications: data
            });
        })
    }

    editApplication(id) {
        window.location = "/jobwizard?sj=" + id;
    }

    render() {
        if (this.state.applications == null) {
            return (
                <Loading/>
            );
        }

        if (this.props.onlineCv) {
            window.location = "/jobwizard?" + globalSns.queryJobId + "=0";
            return;
        }

        var applications = [];

        for (var i = 0; i < this.state.applications.length; i++) {
            var application = this.state.applications[i];

            var item = {
                id: application.jobId,
                text: 
                    <div>
                        <span>{getDateString(getJsonDate(application.creDat))}</span>:&nbsp; 
                        {(application.jobId === 0) ?
                            <span>{application.name}</span> :
                            <a href={"/" + globalSns.cultureAlias + "/jobs/" + application.jobId}>{application.name}</a>}
                        {(application.jobId > 0) ? " - " + application.organisationName : ""}
                        <div>
                            <div>
                                <i>{(application.jobId > 0) ? application.reference : ""}</i>&nbsp;&nbsp;&nbsp;
                                {(application.jobId > 0 && application.isClosed) ? <i className="EditingFormErrorLabel">{getTranslation("sns.webparts.applications.closed")}</i> : ""}
                            </div>
                        </div>
                    </div>,
                editClass: (application.jobId > 0 && application.isClosed) ? "fa fa-search" : null,
                rowClass: (application.jobId > 0 && application.isClosed) ? "active" : null
            };
            applications.push(item);
        }

        return (
            <div className="registration">
                {
                    (this.props.onlineCv) ? 
                        <p><em>{getTranslation("sns.webparts.applications.choose")}</em></p> :
                        ""
                }
                <FormList values={applications} showEdit={true} onEdit={this.editApplication} />
            </div>
        );  
    }
}

export default Applications;


// WEBPACK FOOTER //
// ./src/Components/Pages/Applications.js